"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDisclaimerModalCMS = void 0;
var LegalDisclaimerShortPath_cms_1 = require("./LegalDisclaimerShortPath.cms");
var LegalDisclaimerModalCMS = /** @class */ (function () {
    function LegalDisclaimerModalCMS() {
        this.legalModalPath = [
            '/idpassets/fragment/legal/2005e/legalmodal/offers/wireline/checkout/dtvpaymentmodallm.cmsfeed.js',
        ];
        this.legalShortPath = new LegalDisclaimerShortPath_cms_1.LegalDisclaimerModalShortPathCMS();
    }
    return LegalDisclaimerModalCMS;
}());
exports.LegalDisclaimerModalCMS = LegalDisclaimerModalCMS;
//# sourceMappingURL=LegalDisclaimerModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/LegalDisclaimerModal.cms.js
// module id = 2272
// module chunks = 8